module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(0), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-yellow"
  }), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_c('a', {
    on: {
      "click": _vm.requestAgain
    }
  }, [_vm._v("Clique aqui")]), _vm._v(" para reenviar o código.\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row border-row row-fix"
  }, [_c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "content-box-small margin-t80"
  }, [(_vm.formState == 'ERROR') ? _c('div', {
    staticClass: "alert alert-danger alert-dismissible margin-t20",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v("Erro: ")]), _vm._v("\n              " + _vm._s(_vm.errorMessage) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.formState == 'SUCCESS') ? _c('div', {
    staticClass: "alert alert-success alert-dismissible margin-t20",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v("Sucesso!")]), _vm._v(" "), _vm._v("\n              Um SMS foi enviado para você contendo uma sequência de 6 dígitos.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.formState == 'NEW' || _vm.formState == 'ERROR') ? _c('form', {
    attrs: {
      "autocomplete": "false"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.doRequest.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group margin-b20"
  }, [_c('label', [_vm._v("Código")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.TFACode),
      expression: "TFACode",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control small",
    attrs: {
      "type": "text",
      "maxlength": "6",
      "oninput": "javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);",
      "name": "TFACode",
      "placeholder": "Digite os 6 números",
      "data-vv-validate-on": "blur",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.TFACode)
    },
    on: {
      "keypress": function($event) {
        return _vm.isNumber($event)
      },
      "change": function($event) {
        _vm.TFACode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(""))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-purple",
    attrs: {
      "id": "btn-login",
      "type": "submit",
      "name": "button"
    }
  }, [_vm._v("\n                Continuar\n              ")]), _vm._v(" "), _c('i', {
    staticClass: "icon-circle-right align-icon"
  })]) : _vm._e()])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-back margin-t20",
    attrs: {
      "to": "/login",
      "tag": "button"
    }
  }, [_c('i', {
    staticClass: "icon-circle-left align-icon-left"
  }), _vm._v("\n        Voltar\n      ")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "title"
  }, [_vm._v("\n        Identificação "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n        Autenticação de 2 fatores\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n        Enviamos uma sequência numérica de 6 dígitos para o "), _c('b', [_vm._v("e-mail")]), _vm._v(" e "), _c('b', [_vm._v("número de celular")]), _vm._v(" cadastrados em sua conta. Para continuar, insira o código no campo abaixo:\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "circle-key"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-ffc999a2!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/auth/2fa.vue
// module id = 2227
// module chunks = 1